import { render, staticRenderFns } from "./AstrictMask.vue?vue&type=template&id=03b6a126&scoped=true&"
import script from "./AstrictMask.vue?vue&type=script&lang=js&"
export * from "./AstrictMask.vue?vue&type=script&lang=js&"
import style0 from "./AstrictMask.vue?vue&type=style&index=0&id=03b6a126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b6a126",
  null
  
)

export default component.exports